import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL, FILE_BASE_URL } from '../../../apiConfig';
import useBreakpoint from '../../../hooks/useBreakpoint';

/**
 * MainSponsor Section
 * Displays the official season sponsor in a prominent blue banner.
 * Placed after the Hero slider as per latest design requirements.
 */
export default function MainSponsor() {
    const [sponsor, setSponsor] = useState(null);
    const { isMobile, isTablet, isDesktop } = useBreakpoint();

    useEffect(() => {
        let isMounted = true;
        axios.get(`${API_BASE_URL}/sponsors`)
            .then(res => {
                // Support both {sponsors: {}} and directly returning the object
                const sponsorData = res.data.sponsors || res.data;
                if (isMounted && sponsorData && (sponsorData.image || sponsorData.logo)) {
                    setSponsor(sponsorData);
                }
            })
            .catch(err => console.error("MainSponsor fetch error:", err));
        
        return () => { isMounted = false; };
    }, []);

    return (
        <section style={{
            background: '#ffffff',
            padding: isMobile ? '24px 0' : '40px 0',
            width: '100%',
            boxSizing: 'border-box',
        }}>
            <div style={{
                maxWidth: 'var(--maxWidth)',
                margin: '0 auto',
                padding: isMobile ? '0 16px' : '0 24px',
                boxSizing: 'border-box',
            }}>
                <div style={{
                    background: '#060D8A',
                    display: 'flex',
                    flexDirection: !isDesktop ? 'column' : 'row',
                    flexWrap: !isDesktop ? 'nowrap' : 'wrap',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: !isDesktop ? '32px 24px' : isTablet ? '40px 48px' : '50px 70px',
                    gap: !isDesktop ? '24px' : '40px',
                    position: 'relative',
                    overflow: 'hidden',
                    boxSizing: 'border-box',
                }}>
                    {/* Left Side: Bold Typography */}
                    <div style={{ flex: !isDesktop ? 'none' : '1 1 400px', width: !isDesktop ? '100%' : 'auto' }}>
                        <h2 style={{
                            fontFamily: 'var(--fontDisplay)',
                            fontSize: !isDesktop ? 'clamp(28px, 8vw, 42px)' : 'clamp(36px, 5vw, 60px)',
                            fontWeight: 900,
                            color: '#ffffff',
                            textTransform: 'uppercase',
                            lineHeight: 1,
                            margin: 0,
                            letterSpacing: '1px',
                            textAlign: !isDesktop ? 'center' : 'left',
                        }}>
                            OFFICIAL SPONSOR OF THE<br />
                            SEASON
                        </h2>
                    </div>

                    {/* Right Side: Sponsor Logo Box */}
                    <div style={{
                        flex: !isDesktop ? 'none' : '0 0 450px',
                        width: !isDesktop ? '100%' : 'auto',
                        height: !isDesktop ? '140px' : '200px',
                        background: '#ffffff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '20px',
                        boxSizing: 'border-box',
                        borderRadius: '0px',
                        boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
                    }}>
                        {sponsor ? (
                            <a href={sponsor.link || '#'} target="_blank" rel="noreferrer" style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center',
                                width: '100%',
                                height: '100%'
                            }}>
                                <img 
                                    src={`${FILE_BASE_URL}/${sponsor.image || sponsor.logo}`} 
                                    alt="Official Season Sponsor" 
                                    onLoad={() => console.log("Main Sponsor Logo loaded")}
                                    onError={(e) => {
                                        console.error("Main Sponsor Logo failed to load:", e.target.src);
                                        // e.target.style.display = 'none'; // Optional: hide if broken
                                    }}
                                    style={{ 
                                        maxWidth: '100%', 
                                        maxHeight: '100%', 
                                        objectFit: 'contain' 
                                    }} 
                                />
                            </a>
                        ) : (
                            <div style={{ 
                                color: '#ccc', 
                                fontSize: '14px', 
                                fontWeight: 700, 
                                fontFamily: 'var(--fontBody)',
                                textTransform: 'uppercase'
                            }}>
                                Sponsor Logo
                            </div>
                        )}
                    </div>

                    {/* Subtle aesthetic accent (optional overlay) */}
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        width: '30%',
                        height: '100%',
                        background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.03))',
                        pointerEvents: 'none'
                    }} />
                </div>
            </div>
        </section>
    );
}
